import * as yup from "yup";

import { checkSINValidity } from "../../../common/Common";

export const ClientSetupValidationSchema = yup.object({
	companyId: yup.string().max(10, "Maximum length 10 characters"),

	legalName: yup
		.string()
		.required("Legal Name is required")
		.min(1, "Minimum length 1 characters")
		.max(100, "Maximum length 100 characters"),
	// operatingName: yup
	// .string()
	// .required("Operating Name is required")
	// .min(1, "Minimum length 1 characters")
	// .max(100, "Maximum length 100 characters"),
	addressLine1: yup
		.string()
		.required("Address is required")
		.min(1, "Minimum length 1 characters")
		.max(100, "Maximum length 100 characters"),
	city: yup
		.string()
		.required("City is required")
		.min(1, "Minimum length 1 characters")
		.max(30, "Maximum length 30 characters"),
	province: yup.string().required("Province is required"),
	country: yup.string().required("Country is required"),
	systemAlertsFrom: yup
		.string()
		.email("Must be a valid email address")
		.required("System Alerts From is required")
		.max(100, "Maximum length 100 characters"),
	stubEmailFrom: yup
		.string()
		.email("Must be a valid email address")
		.max(100, "Maximum length 100 characters"),
	website: yup.string().max(50, "Maximum length 50 characters"),
});
